import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Slider,
  TextField,
  Tooltip
} from '@mui/material';
import { SetStateAction, useState } from 'react';
import { ReactComponent as GitBranch } from '../assets/icon/GitBranch.svg';
import { ReactNode } from 'react';
import { Autocomplete } from '@mui/material';
import { ReactComponent as I_icon } from '../assets/icon/i_icon.svg';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import useCloudProvider from '../hooks/useCloudProvider';

export function headerFunction(name: string, isMandatory: boolean, toolTip: '') {
  return (
    <p className="m-0 h5_400 w600 my-1">
      {' '}
      {name}
      {isMandatory && <span style={{ color: 'var(--red-color)' }}>*</span>}
      {toolTip && (
        <span className="ms-1">
          <ToolTipFunction toolTipText={<>{toolTip}</>}>
            <I_icon style={{ width: 15 }} />
          </ToolTipFunction>
        </span>
      )}
    </p>
  );
}

const availableVersions = [{ title: '', id: 1 }];
export default function DropDownComponent({
  optionName = '',
  fieldName = 'Version',
  options = availableVersions,
  isMandatory = false,
  paramName = '',
  handleSelection = (a?: string, b?: string) => {},
  value = ''
}) {
  return (
    <div className="my-3">
      {headerFunction(fieldName, isMandatory)}
      <select
        value={value}
        className="form-select"
        aria-label="Default select example"
        aria-placeholder={`Select ${fieldName}`}
        onChange={(e) => handleSelection(paramName, e.target.value)}>
        <option selected style={{ color: 'var(--grey_tone)' }}>
          Select {fieldName}
        </option>
        {options?.map((item, index) => (
          <option value={item?.id} key={item?.title + index}>
            {optionName} {item?.title}
          </option>
        ))}
      </select>
    </div>
  );
}

export function SearchableDropDownComponent({
  optionName = '',
  fieldName = 'Version',
  options = [],
  isMandatory = false,
  paramName = '',
  handleSelection = (a = '', b = '') => {},
  value = ''
}) {
  // Find the currently selected option
  const selectedOption = options.find((item) => item.id === value) || null;

  return (
    <div className="my-3">
      {headerFunction(fieldName, isMandatory)}

      {/* <InputLabel id="demo-simple-select-label">{paramName}</InputLabel> */}

      <Autocomplete
        fullWidth
        id="searchable-dropdown"
        value={selectedOption}
        options={options}
        onChange={(event, newValue) => handleSelection(paramName, newValue ? newValue.id : '')}
        getOptionLabel={(option) => `${optionName} ${option.title || ''}`}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            label="" // No visible label
            InputLabelProps={{ shrink: false }} // Prevent floating label
            placeholder={`Select/Search ${fieldName}`} // Use placeholder instead
          />
        )}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        clearOnBlur
        popupIcon={<KeyboardArrowDownIcon sx={{ transition: '0.2s' }} />}
        sx={{
          '& .MuiAutocomplete-popupIndicatorOpen': {
            transform: 'rotate(180deg)'
          }
        }}
      />
    </div>
  );
}

export function TextFieldComponent({
  header = '',
  isMandatory = false,
  placeholder = '',
  paramName = '',
  handleSelection = (a: string, b: string) => {},
  value = '',
  disabled = false,
  divCss = 'my-3',
  divStyle = {},
  error = false
}: {
  header?: string;
  isMandatory?: boolean;
  placeholder?: string;
  paramName?: string;
  handleSelection?: (a: string, b: string) => void;
  value?: string;
  disabled?: boolean;
  divCss?: string;
  divStyle?: {};
  error?: boolean;
}) {
  return (
    <div className={divCss}>
      {' '}
      {headerFunction(header, isMandatory)}
      <div className="input-group input-group-lg">
        <div className="input-group-prepend"></div>
        <input
          type="text"
          disabled={disabled}
          placeholder={placeholder}
          className="form-control h5_400"
          aria-label="Large"
          aria-describedby="inputGroup-sizing-sm"
          value={value}
          name={paramName}
          onChange={(e) => {
            handleSelection(paramName, e.target.value);
          }}
          style={{
            borderRadius: 4,
            border: '1px solid rgba(228, 228, 228, 1)',
            padding: '12px',
            fontWeight: 400,
            ...divStyle
          }}
        />
      </div>
      {error && <div className="invalid-feedback d-block">This Name is already Used.</div>}
    </div>
  );
}

export function TextArea({
  header = '',
  description = '',
  numberOfLines = 10,
  placeholder = '',
  areaStyle = {},
  action = (a: string) => {},
  value = '',
  toolTip = '',
  onKeyDown = (a: any) => {},
  isMandatory = false,
  disabled = false
}) {
  return (
    <form>
      {header && headerFunction(header, isMandatory, toolTip)}
      {description && (
        <p className="h7_400" style={{ color: 'var(--description_grey)' }}>
          {description}
        </p>
      )}
      <div className="form-group d-flex">
        {/* <label for="exampleFormControlTextarea1">Example textarea</label> */}
        <textarea
          className="form-control h5_400"
          id="exampleFormControlTextarea1"
          disabled={disabled}
          rows={numberOfLines}
          value={value}
          style={{
            border: '1px solid var(--border-color-grey)',
            borderRadius: 4,
            padding: 16,
            resize: 'none',
            fontWeight: 400,
            ...areaStyle
          }}
          placeholder={placeholder}
          onChange={(e) => action(e.target.value)}
          // /
          onKeyDown={onKeyDown}></textarea>
      </div>
    </form>
  );
}

export function RangeSelector({
  name = 'Range',
  min = 0,
  max = 100,
  step = 1,
  value = 0,
  paramName = '',
  handleSelection = (a: string, b: string) => {},
  toolTip = ''
}) {
  // const [value, setValue] = useState('0');
  // const [value, setValue] = useState('0');

  function handleChangeFunction(e) {
    // setValue(e.target.value);
    // setValue(e.target.value);
    handleSelection(e.target.name, e.target.value);
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%'
        }}>
        {headerFunction(name, false, toolTip)}
        <TextFieldComponent
          placeholder={paramName}
          divCss={'w-25'}
          divStyle={{
            width: '50px',
            height: '30px',
            border: '1px solid rgba(0, 102, 204, 0.5)',
            borderRadius: 4
          }}
          value={value}
          paramName={paramName}
          handleSelection={(a, b) => {
            if (b < min || b > max) {
              alert(`choose values between ${min} to ${max}`);
              return;
            }
            handleSelection(a, b);
          }}
        />
      </div>

      <Slider
        sx={{
          '& .MuiSlider-rail': {
            color: 'var(--border-color-grey)' // unselected track color
          },
          '& .MuiSlider-track': {
            color: 'var(--uni_std_clr)' // selected track color
          },
          '& .MuiSlider-thumb': {
            color: 'white',
            width: '10px',
            height: '10px',
            border: '1px solid var(--uni_std_clr)' // thumb color (optional)
          }
        }}
        min={min}
        max={max}
        step={step}
        value={value}
        aria-label="Default"
        name={paramName}
        // handleChange={ handleSelection}
        // valueLabelDisplay="auto"
        onChange={handleChangeFunction}
      />
    </>
  );
}

export function BlueDropDownComponent({
  versionsData = [{ version: '', creation_date: '' }],
  selectedVersion = 0,
  paramName = '',
  handleSelection = (a: string, b: number) => {}
}) {
  return (
    <FormControl style={{ width: '100px', height: '34px' }}>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        label={paramName}
        onChange={(e) => {
          handleSelection(paramName, e.target.value);
        }}
        value={selectedVersion}
        renderValue={(selected) => {
          return (
            <>
              <GitBranch className="me-2" />
              {selected}
            </>
          );
        }}
        sx={{
          backgroundColor: 'rgba(242, 247, 254, 1)',
          width: '100%',
          height: '100%',
          color: 'var(--uni_std_clr)',
          border: 'none',
          '.MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          }
        }}

        // onChange={(e) => handleSelection(paramName, e.target.value)}
      >
        {/* {arr?.map((item, index) => (
          <MenuItem value={index + 1} key={'version' + index}>
            Version {index + 1}
          </MenuItem>
        ))} */}
        {versionsData?.map((item, index) => (
          <MenuItem value={item?.version} key={'version' + index}>
            Version {item?.version}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

type RadioButtonType = {
  options: { id: number; text: string; checked: boolean }[];
  handleSelection: (a: number) => void;
  versionDetail?: { selected: 0; total: 0 };
  isEditPrompt?: boolean;
  newVersion?: number;
};

export function RadioButtonGroup({
  options,
  handleSelection,
  versionDetail = { selected: 0, total: 0 },
  isEditPrompt,
  newVersion
}: RadioButtonType) {
  return (
    <>
      {options?.map((option: { id: number; text: string; checked: boolean }, index) => (
        <div key={option?.text}>
          <input
            onChange={() => handleSelection(index)}
            type="radio"
            id={`radio-${option?.id}`}
            name="radio-group"
            value={option?.id}
            checked={option?.checked}
            style={{ cursor: 'pointer' }}
          />
          <label
            htmlFor={`radio-${option?.id}`}
            style={{
              color: 'var(--grey_tone)',
              marginLeft: 5,
              width: '50%'
            }}>
            {option?.text}
            {isEditPrompt && option?.checked && (
              <div
                style={{
                  width: '50px',
                  height: '20px',
                  // padding: '10px',
                  textAlign: 'center',
                  display: 'inline-block',
                  backgroundColor: 'rgba(242, 247, 254, 1)',
                  borderRadius: '4px',
                  color: 'var(--uni_std_clr)',
                  marginLeft: 10
                }}>
                {[versionDetail?.selected, newVersion][index]}
              </div>
            )}
          </label>
        </div>
      ))}
    </>
  );
}

export function ToolTipFunction({
  children = <></>,
  toolTipText = <></>,
  placement = 'right'
}: {
  children?: ReactNode;
  toolTipText?: React.ReactElement | string;
  placement?: string;
}) {
  return (
    <div className="d-inline cursor-pointer">
      <Tooltip
        arrow
        title={toolTipText}
        placement={placement}
        className="h7_400"
        style={{ cursor: 'pointer' }}
        slotProps={{
          popper: {
            modifiers: [
              {
                name: 'offset',
                options: { offset: [0, -10] }
              }
            ]
          },
          tooltip: {
            sx: {
              backgroundColor: 'rgba(0, 0, 0, 1)',
              color: 'rgba(255, 255, 255, 1)',
              padding: '6px',
              borderRadius: '4px',
              [`& .MuiTooltip-arrow`]: {
                color: 'rgba(0, 0, 0, 1)'
              }
            }
          }
        }}>
        {children}
      </Tooltip>
    </div>
  );
}

export function CloudProvider({
  cloudProvidersList,
  selectedCloud,
  selectCloud,
  sideAction = () => {},
  disabled = false
}: any) {
  return (
    <div className="col-md-4">
      <p className="my-1 unl-label-p">
        Cloud Provider<span style={{ color: 'red' }}>*</span>
      </p>
      <select
        className={`form-select`}
        value={selectedCloud}
        disabled={disabled}
        required
        onChange={(e) => {
          selectCloud(parseInt(e.target.value));
          sideAction();
        }}>
        <option value="">Select Cloud Provider</option>
        {cloudProvidersList?.map((item: { id: number; name: string }) => (
          <option value={item?.id}>{item?.name}</option>
        ))}
      </select>
    </div>
  );
}

export function CloudProviderFilter({ cloudProvidersList, selectedCloud, selectCloud }: any) {
  return (
    <div className="filter-section">
      <label>Cloud Provider</label>
      <button className="reset-link" onClick={() => selectCloud(0)}>
        Reset
      </button>
      <select value={selectedCloud} onChange={(e) => selectCloud(parseInt(e.target.value))}>
        <option value="">Select</option>
        {cloudProvidersList.map((item) => (
          <option key={item?.id} value={item?.id}>
            {item?.name}
          </option>
        ))}
      </select>
    </div>
  );
}
